import { combineReducers } from "redux";

import { reminderSchedulesReducer as reminderShedules } from "./reminderSchedulesReducer";

export const reminderSchedulesReducer = combineReducers({
  reminderShedules,
});
